import {fetchMessages} from '../api'
import {useInfiniteQuery, useQueries} from 'react-query'
import {fetchStudentList} from '../../student/api'
import {fetchDivisionList} from '../../division/api'
import {fetchClassList} from '../../class/api'
import {Message} from '../types'

export type FetchMessagesResponse = {
  data: Message[]
  hasMore: boolean
}

const useData = () => {
  const results = useQueries([
    {
      queryKey: 'class',
      queryFn: fetchClassList,
      refetchOnWindowFocus: false,
      //   staleTime: 60000,
    },
    {
      queryKey: 'division',
      queryFn: fetchDivisionList,
      refetchOnWindowFocus: false,
      //   staleTime: 60000,
    },
    {
      queryKey: 'students',
      queryFn: () => fetchStudentList({studentClass: '', division: ''}),
      refetchOnWindowFocus: false,
      //   staleTime: 60000,
    },
  ])

  const messagelimit = 7

  const messageQueryResult = useInfiniteQuery<FetchMessagesResponse>({
    queryKey: 'messages',
    queryFn: ({pageParam = 0}) => fetchMessages({pageParam, limit: messagelimit}),
    getNextPageParam: (lastPage, allPages) => (lastPage.hasMore ? allPages.length : undefined), // Calculate the next page param
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    cacheTime: 10 * 60 * 1000,
    retry: 3,
  })

  const [
    {data: classes, isFetching: isLoadingClasses},
    {data: divisions, isFetching: isLoadingDivisions},
    {data: students, isFetching: isLoadingStudents},
  ] = results

  const {
    data,
    fetchNextPage: fetchMoreMessages,
    hasNextPage,
    isFetchingNextPage: isFetchingMoreMessages,
    isLoading: isLoadingMessages,
    isRefetching: isRefetchingMessages,
  } = messageQueryResult

  const messages = data?.pages.flatMap((page) => page.data) || []

  const checkHasMoreMessages = (): boolean => {
    // if the offset equals to the total message entries in the db
    // api gives empty array, which means no more mssages
    return messages.length === 0 ? false : hasNextPage ?? false
  }

  const initialLoading =
    isLoadingClasses || isLoadingDivisions || isLoadingStudents || isLoadingMessages

  const messageDataHelpers = {
    fetchMoreMessages,
    hasMoreMessages: checkHasMoreMessages(),
    isFetchingMoreMessages,
    isRefetchingMessages,
  }

  return {
    classes,
    divisions,
    students,
    messages,
    initialLoading,
    messageDataHelpers,
  }
}

export default useData
